var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsbDriver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 20,
    viewBox: "0 0 9 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 0.625C1.5 0.45924 1.56585 0.300269 1.68306 0.183058C1.80027 0.065848 1.95924 0 2.125 0L7.125 0C7.29076 0 7.44973 0.065848 7.56694 0.183058C7.68415 0.300269 7.75 0.45924 7.75 0.625V5.625H1.5V0.625ZM2.75 1.25V2.5H4V1.25H2.75ZM5.25 1.25V2.5H6.5V1.25H5.25ZM0.875 6.25C0.70924 6.25 0.550269 6.31585 0.433058 6.43306C0.315848 6.55027 0.25 6.70924 0.25 6.875V18.75C0.25 19.0815 0.381696 19.3995 0.616117 19.6339C0.850537 19.8683 1.16848 20 1.5 20H7.75C8.08152 20 8.39946 19.8683 8.63388 19.6339C8.8683 19.3995 9 19.0815 9 18.75V6.875C9 6.70924 8.93415 6.55027 8.81694 6.43306C8.69973 6.31585 8.54076 6.25 8.375 6.25H0.875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsbDriver);
export default __webpack_public_path__ + "static/media/USBDriver.e4c12741e3a50967f98e86cf93289611.svg";
export { ForwardRef as ReactComponent };